import React from 'react';
import { Box, Typography } from '@mui/material';
import { describeLeadProfile } from '../leadProfile';
import { LEADS_TEXT_MUTED, LEADS_TEXT_PRIMARY } from './leadsUi.styles';

const gridSx = {
  display: 'grid',
  gridTemplateColumns: 'minmax(96px, auto) minmax(0, 1fr)',
  columnGap: 1.5,
  rowGap: 0.5,
  m: 0,
  mt: 0.25,
};
const labelSx = { fontSize: '12px', color: LEADS_TEXT_MUTED, lineHeight: '18px', m: 0 };
const valueSx = { fontSize: '13px', color: LEADS_TEXT_PRIMARY, lineHeight: '18px', m: 0, overflowWrap: 'anywhere' };

/**
 * Datos del cliente (`profile`) en lectura compacta: solo los campos con
 * dato (edad junto a la fecha, hijos con edades). Sin datos → nada.
 *
 * @param {{ profile: object|null }} props
 */
export default function LeadProfileSummary({ profile }) {
  const rows = describeLeadProfile(profile);
  if (!rows.length) return null;
  return (
    <Box component="dl" data-testid="lead-profile-summary" aria-label="Datos del cliente" sx={gridSx}>
      {rows.map((row) => (
        <React.Fragment key={row.key}>
          <Typography component="dt" sx={labelSx}>{row.label}</Typography>
          <Typography component="dd" sx={valueSx}>{row.value}</Typography>
        </React.Fragment>
      ))}
    </Box>
  );
}
